import React, { useState } from 'react'
import styles from './StageVocabulary.module.css'
import Phase1 from './Phase1/Phase1';
import Phase2 from './Phase2/Phase2';
import Phase3 from './Phase3/Phase3';
import Phase4 from './Phase4/Phase4';


const StageVocabulary = ({
    data,
    onPageChange,
}) => {

    // data.words -> array
    // word -> eng, gender, heb, vow, img_path, sound_path

    const [phase, setPhase] = useState(1)

    const handleNextPhase = () => {
        setPhase(prevPhase => prevPhase + 1);
    }

    let phaseContent = null

    switch (phase) {
        case 1:
            phaseContent = <Phase1
                words={data.words}
                onNextPhase={handleNextPhase} />

            break;
        case 2:
            phaseContent = <Phase2
                words={data.words}
                onNextPhase={handleNextPhase}
                onProgress={onPageChange} />
            break;
        case 3:
            phaseContent = <Phase3
                words={data.words}
                onNextPhase={handleNextPhase}
                onProgress={(index) => onPageChange(index + data.words.length)} />
            break
        case 4:
            phaseContent = <Phase4
                words={data.words}
                onNextPhase={handleNextPhase} />
            break;
        case 5:
            //DONE
            break
        default: phaseContent = null
    }

    return (
        <div className={styles.container}>
            {phaseContent}
        </div>
    )
}

export default StageVocabulary
